import { render, staticRenderFns } from "./assessment.vue?vue&type=template&id=55ac15dc&scoped=true&"
import script from "./assessment.vue?vue&type=script&lang=js&"
export * from "./assessment.vue?vue&type=script&lang=js&"
import style0 from "./assessment.vue?vue&type=style&index=0&id=55ac15dc&scoped=scoped&lang=css&"
import style1 from "./assessment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac15dc",
  null
  
)

export default component.exports